import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("Missing root element.");
}

const app = (
	<StrictMode>
		<App />
	</StrictMode>
);

if (import.meta.hot) {
	// With hot module reloading, `import.meta.hot.data` is persisted.
	const root = (import.meta.hot.data.root ??= createRoot(rootElement));
	root.render(app);
} else {
	// The hot module reloading API is not available in production.
	createRoot(rootElement).render(app);
}
